import { render, staticRenderFns } from "./InhouseLifecycle.vue?vue&type=template&id=19261d4d&scoped=true"
import script from "./InhouseLifecycle.vue?vue&type=script&lang=js"
export * from "./InhouseLifecycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19261d4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\BabaBello\\bababelloapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19261d4d')) {
      api.createRecord('19261d4d', component.options)
    } else {
      api.reload('19261d4d', component.options)
    }
    module.hot.accept("./InhouseLifecycle.vue?vue&type=template&id=19261d4d&scoped=true", function () {
      api.rerender('19261d4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lifecycle/InhouseLifecycle.vue"
export default component.exports